export const menuItems = [
  {
    name: "Inicio",
    link: "/",
  },
  {
    name: "Cursos",
    link: "/cursos",
    subItems: [
      { id: 1, name: "Bkids", link: "/cursos/bkids" },
      {
        id: 2,
        name: "Curso de Eficiencia Comunicativa en Inglés",
        link: "/cursos/cursos-basicos",
      },
      {
        id: 3,
        name: "Cursos por Habilidades",
        link: "/cursos/cursos-por-habilidades",
      },
      {
        id: 4,
        name: "Cursos Personalizados",
        link: "/cursos/cursos-personalizados",
      },
      {
        id: 5,
        name: "Cursos Especializado",
        link: "/cursos/cursos-especializado",
      },
      {
        id: 6,
        name: "Cursos de Vacaciones",
        link: "/cursos/cursos-de-vacaciones",
      },
    ],
  },
  {
    name: "Certifica tu Inglés",
    link: "/certificaciones",
    subItems: [
      { id: 7, name: "IELTS", link: "/certificaciones/ielts" },
      { id: 8, name: "TOEFL", link: "/certificaciones/toefl" },
      { id: 9, name: "APTIS", link: "/certificaciones/aptis" },
      { id: 10, name: "OOPT", link: "/certificaciones/oopt" },
      // { id: 10, name: "Cursos de Vacaciones", link: "/cursos/cursos-de-vacaciones" },
    ],
  },
  {
    name: "Nuestro Equipo",
    link: "/nosotros",
    subItems: [
      { id: 11, name: "Acerca de Nosotros", link: "/nosotros" },
      { id: 12, name: "Teachers", link: "/nosotros/teachers" },
      { id: 13, name: "Testimonios", link: "/nosotros/testimonios" },
      { id: 14, name: "Contactanos", link: "/nosotros/contactanos" },
      // { id: 4, name: "Cursos Personalizados", link: "/cursos/cursos-personalizados" },
      // { id: 5, name: "Cursos de Vacaciones", link: "/cursos/cursos-de-vacaciones" },
    ],
  },
  {
    name: "Consulta de Notas",
    a: "https://sistema.brightonenglishcenter.edu.co/#/",
  },
];
